import React from 'react';
import { cn } from '@/shared/utils/cn';
import { SidebarDividerProps } from '../../types';

/**
 * ============================================
 * SIDEBAR DIVIDER - ATOM
 * ============================================
 * Separador para el sidebar. Puede ser una línea simple
 * o incluir un texto descriptivo.
 */
export const SidebarDivider: React.FC<SidebarDividerProps> = ({
  className,
  withText = false,
  text,
}) => {
  if (withText && text) {
    return (
      <div className={cn('ui-flex ui-w-full ui-items-center ui-gap-8', className)}>
        <span className="ui-shrink-0 ui-whitespace-nowrap ui-text-body-xs-regular ui-font-body-xs-regular ui-text-tertiary">
          {text}
        </span>
        <div className="ui-flex-1 ui-border-t-1 ui-border-default" />
      </div>
    );
  }

  return (
    <div className={cn('ui-w-full ui-py-4', className)}>
      <div className="ui-border-t-1 ui-border-default" />
    </div>
  );
};
